(function () {
  'use strict';

  const sectionHandlers = new WeakMap();

  const lockScroll = () => {
    const scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${scrollY}px`;
  };

  const unlockScroll = () => {
    const scrollY = parseInt(document.body.style.top || '0', 10) * -1;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  };

  const initBogoOfferBanner = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const trigger = root.querySelector('[data-bogo-offer-banner-trigger]');
    const dialog = root.querySelector('[data-bogo-offer-banner-dialog]');
    const closeBtn = root.querySelector('[data-bogo-offer-banner-close]');

    if (!trigger || !dialog) {
      root.dataset.initialized = 'true';
      return;
    }

    const openDialog = () => {
      lockScroll();
      dialog.showModal();
    };

    const closeDialog = () => {
      unlockScroll();
      dialog.close();
      trigger.focus();
    };

    const onTriggerClick = () => openDialog();

    const onCloseClick = () => closeDialog();

    const onCancel = (event) => {
      event.preventDefault();
      closeDialog();
    };

    const onBackdropClick = (event) => {
      if (event.target === dialog) closeDialog();
    };

    const onLinkClick = (event) => {
      const link = event.target.closest('[data-bogo-offer-banner-link]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href || href === '#') {
        event.preventDefault();
        closeDialog();
        return;
      }

      if (href.startsWith('#')) {
        event.preventDefault();
        const scrollTarget = document.querySelector(href);
        closeDialog();
        scrollTarget?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      closeDialog();
    };

    trigger.addEventListener('click', onTriggerClick);
    closeBtn?.addEventListener('click', onCloseClick);
    dialog.addEventListener('cancel', onCancel);
    dialog.addEventListener('click', onBackdropClick);
    dialog.addEventListener('click', onLinkClick);

    sectionHandlers.set(root, {
      trigger,
      closeBtn,
      dialog,
      onTriggerClick,
      onCloseClick,
      onCancel,
      onBackdropClick,
      onLinkClick,
    });

    root.dataset.initialized = 'true';
  };

  const cleanupBogoOfferBanner = (root) => {
    const handlers = sectionHandlers.get(root);
    if (!handlers) return;

    handlers.trigger.removeEventListener('click', handlers.onTriggerClick);
    handlers.closeBtn?.removeEventListener('click', handlers.onCloseClick);
    handlers.dialog.removeEventListener('cancel', handlers.onCancel);
    handlers.dialog.removeEventListener('click', handlers.onBackdropClick);
    handlers.dialog.removeEventListener('click', handlers.onLinkClick);
    sectionHandlers.delete(root);
  };

  const initAll = () => {
    document.querySelectorAll('[data-bogo-offer-banner]:not([data-initialized="true"])').forEach(initBogoOfferBanner);
  };

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-bogo-offer-banner]');
    if (root) initBogoOfferBanner(root);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('[data-bogo-offer-banner]');
    if (root) cleanupBogoOfferBanner(root);
  });
})();
